/**
 * Created by daniel on 11/04/17.
 */
import React, { Component } from 'react';
import CanvasContainer from './components/ui/CanvasContainer';
import {connect} from "react-redux";
import {setUiDropzoneCoords, setUiSelectedContentItem, setUiToolboxVisibility} from "./state/ui/actions";
import ToolBoxContainer from "./components/ui/ToolBox/ToolBoxContainer";
import {getUiDropzoneCoords, getUiSelectedItem, getUiToolboxPinned, getUiToolboxVisibility} from "./state/ui/selectors";
import './Editor.css';
import {IconButton, Toolbar, ToolbarGroup, ToolbarSeparator} from "material-ui";
import {ActionCreators} from 'redux-undo'
import ExportDialogContainer from "./components/ui/ExportDialogContainer";
import {createContentItem, setContentItems} from "./state/content/actions";
import {getContentDefinitions} from "./state/config/selectors";
import * as _ from "lodash";
import {getTemplateItems} from "../state/templates/selectors";

class Editor extends Component {
  constructor(props) {
    super(props);
    this.state = {exportDialogOpen: false};
    console.log("editor-created");

    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleExportDialogVisibility = this.handleExportDialogVisibility.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }
  
  handleOnClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.selectedItem && this.props.clearSelectedItem();
  };
  handleDragOver(e) {
    if (this.props.dropzoneCoords) this.props.clearDropzoneCoords();
    e.stopPropagation();
  };
  
  handleExportDialogVisibility(visible) {
    this.setState({exportDialogOpen: visible});
  };
  
  componentDidMount() {
    console.log("editor-mounted");
  
    // Work out which template to set the state to, if any
    let routeParams = this.props.route.match.params;
    if (_.isEmpty(routeParams)) {
      // Create an empty element
      this.props.dispatch(setContentItems([]));
      this.props.dispatch(createContentItem(null, null, "ROOT_ITEM", getContentDefinitions(this.props.state)));
    } else {
      // Load the appropriate template
      let template = _.head(getTemplateItems(this.props.state, {templateId: routeParams.id}));
      this.props.dispatch(setContentItems(template.templateContent));
    }
  };
  
  render() {
    return (
      <div id="editor-container"
           onClick={this.handleOnClick}
           onDragOver={this.handleDragOver}
           style={{
             height: "calc(100% - 56px)",
             width: this.props.toolboxPinned && this.props.toolBoxVisible ? "calc(100% - 600px" : "100%",
             //transition: "width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
             overflowY: "scroll",
             paddingTop: "56px",
             position: "relative",
           }}>
        <ToolBoxContainer/>
        <Toolbar style={{
          position: "fixed",
          top: 0,
          width: this.props.toolboxPinned && this.props.toolBoxVisible ? "calc(100% - 600px" : "100%",
          transition: "width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
          zIndex: 1000
        }}>
          <ToolbarGroup firstChild={true}>
            {/*<IconButton tooltip="Redo" iconClassName="material-icons" disabled={!this.props.canRedo} onTouchTap={this.props.onRedo}>file_download</IconButton>*/}
            <IconButton tooltip="Undo" iconClassName="material-icons" disabled={!this.props.canUndo} onTouchTap={this.props.onUndo}>undo</IconButton>
            <IconButton tooltip="Redo" iconClassName="material-icons" disabled={!this.props.canRedo} onTouchTap={this.props.onRedo}>redo</IconButton>
            <ToolbarSeparator/>
            <IconButton tooltip="Export Data" iconClassName="material-icons" onTouchTap={() => this.handleExportDialogVisibility(true)}>file_download</IconButton>
          </ToolbarGroup>
          
          <ToolbarGroup
            style={{
              width: "500px",
              position: "absolute",
              left: "calc(50% - 260px)"
            }}
          >
            {/*<TextField*/}
              {/*id="template-name-input"*/}
              {/*fullWidth={true}*/}
              {/*defaultValue="Default Value"*/}
            {/*/>*/}
            {/*<IconButton tooltip="Save Template" iconClassName="material-icons" disabled={!this.props.canRedo} onTouchTap={this.props.onRedo}>save</IconButton>*/}
          </ToolbarGroup>
          <ToolbarGroup lastChild={true}>
            <IconButton
              tooltip={this.props.toolBoxVisible ? "Close Toolbox" : "Open Toolbox"}
              iconClassName="material-icons"
              iconStyle={{
                transform: this.props.toolBoxVisible ? "rotate(180deg)" : ""
              }}
              onTouchTap={this.props.toolBoxVisible ? this.props.closeToolbox : this.props.openToolbox}>chevron_left
            </IconButton>
          </ToolbarGroup>
        </Toolbar>
        
        <CanvasContainer/>
        <ExportDialogContainer
          open={this.state.exportDialogOpen}
          handleVisibility={this.handleExportDialogVisibility}
        />
      </div>
    );
  }
}

function mapStateToProps (state, ownProps) {
  return {
    canUndo: state.editor.content.past.length > 0,
    canRedo: state.editor.content.future.length > 0,
    toolBoxVisible: getUiToolboxVisibility(state),
    toolboxPinned: getUiToolboxPinned(state),
    selectedItem: getUiSelectedItem(state),
    dropzoneCoords: getUiDropzoneCoords(state),
    state,
    ownProps
  }
}
function mapDispatchToProps(dispatch) {
  return {
    onUndo: () => dispatch(ActionCreators.undo()),
    onRedo: () => dispatch(ActionCreators.redo()),
    clearSelectedItem: () => dispatch(setUiSelectedContentItem(null)),
    clearDropzoneCoords: () => dispatch(setUiDropzoneCoords(null)),
    openToolbox: () => dispatch(setUiToolboxVisibility(true)),
    closeToolbox: () => dispatch(setUiToolboxVisibility(false)),
    dispatch,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Editor);


// WEBPACK FOOTER //
// ./src/App/Editor/Editor.js